module.exports = __webpack_public_path__ + "img/RBS04_6.c5cd332d.jpg";